import axios from 'axios'

export const searchTypes = {
    'all': 'همه',
    'category': 'دسته‌بندی',
    'brand': 'برند',
    'product': 'محصول',
    'content': 'پست/برگه',
    'course': 'دوره',
}

export default {
    namespaced: true,
    state: {
        result: {}
    },
    mutations: {
        setResult(state, {data, stateMode = 'clear'}) {
            if (stateMode === 'append') {
                state.result = {...state.result, ...data}
            } else {
                state.result = data
            }
        },
    },
    actions: {
        search({commit}, {type, words, page = 1, stateMode = 'clear'}) {
            axios.get(`site/general-search?type=${type}&words=${words}&page=${page}`)
                .then(res => {
                    const data = res.data.data
                    commit('setResult', {data, stateMode})
                })
                .catch(error => {
                    console.log(error)
                })
        },
    },
    getters: {
        getResult: state => state.result,
    },
}